import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import Lodge from './components/Lodge';
import Birding from './components/Birding';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                <Hero />
                <Gallery />
                <Lodge />
                <Birding />
                <Experience />
                <Contact />
              </motion.div>
            } />
            <Route path="/gallery" element={<Gallery standalone />} />
            <Route path="/lodge" element={<Lodge standalone />} />
            <Route path="/birding" element={<Birding standalone />} />
            <Route path="/experience" element={<Experience standalone />} />
            <Route path="/contact" element={<Contact standalone />} />
          </Routes>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
}

export default App;